import { reportNotesTransferredTypes } from './types';
import { newDate } from "helpers/dateTools";

const { SET_REPORT_NOTES_TRANSFERRED_FILTERS } = reportNotesTransferredTypes;

const initialState = {
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportNotesTransferredReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_REPORT_NOTES_TRANSFERRED_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value
      }
    default:
      return state;
  }
};